<template>
  <div class="home">
    <topmenu
      @refresh="fetchCards"
      @add="onAddModal"
    />

    <section class="section">
      <div class="container">
        <SearchCards
          @fetch="fetchCards"
        />
      </div>

      <div class="container">
        <b-table
          :data="cards"
          striped
          hoverable
          checkable
          :selected.sync="cardData"
          :checked-rows.sync="cardsChecked"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="№" width="40" numeric>
              {{ startindex + props.index + 1 }}
            </b-table-column>
  
            <b-table-column field="name" label="Имя">
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="phone" label="Телефон">
              {{ props.row.phone }}
            </b-table-column>

            <!-- <b-table-column
              field="phone"
              label="Дата народження"
            >{{props.row.bday || 'не вказано'}}</b-table-column> -->

            <b-table-column field="id" label="Номер картки">
              <strong class="tag is-success">{{ props.row.id }}</strong>
            </b-table-column>

            <b-table-column field="bonuses" label="Бонуси" centered>
              {{ props.row.bonuses }}
            </b-table-column>

            <b-table-column
              field="lang"
              label="Язык"
              centered
            >
              {{ props.row.en == 1 ? 'EN' : 'UA' }}
            </b-table-column>

            <b-table-column field="comment" label="Комментарий" centered>
              {{ props.row.comment }}
            </b-table-column>
            
            <b-table-column field="edit" label="Изменить" centered>
              <button class="button is-small" @click="onEditModal(props.row)">
                <b-icon icon="account-edit"></b-icon>
              </button>

              <button class="button is-small mgl-1" @click="remove(props.row)">
                <b-icon icon="delete"></b-icon>
              </button>
            </b-table-column>
          </template>
        </b-table>

        <Pagination
          :page="page"
          :page-count="pageCount"
          @update="fetchCards"
        />
      </div>
    </section>

    <CardModal
      v-if="cardModalVisibled"
      :card="cardData"
      @close="cardModalVisibled = false"
      @refresh="fetchCards"
    />

    <SmsModal
      v-if="SMSModalVisibled"
      :cards="cardsChecked"
      @close="SMSModalVisibled = false"
    />

    <div class="add-fixed-button">
      <b-button type="is-warning" @click="SMSModalVisibled = true">
        Отправить SMS
      </b-button>

      <b-button type="is-info" @click="onAddModal" icon-left="plus" />
    </div>
  </div>
</template>

<script>

import { api } from "@/api";

import topmenu from "@/components/menu.vue";

import SmsModal from './components/SmsModal.vue';
import CardModal from './components/CardModal.vue';
import Pagination from './components/Pagination.vue'
import SearchCards from './components/SearchCards.vue';

export default {
  name: "home",

  components: {
    topmenu,
    SmsModal,
    CardModal,
    Pagination,
    SearchCards
  },

  data() {
    return {
      cardsChecked: [],
      cards: [],

      SMSModalVisibled: false,

      cardData: {},
      cardModalVisibled: false,

      pageCount: 1
    };
  },

  computed: {
    page() {
      let query = this.$route.query || {}

      return query.page || 1
    },

    startindex () {
      return (this.page - 1) * 50
    }
  },

  mounted() {
    this.fetchCards();
  },

  methods: {
    onEditModal(row) {
      this.cardData = { ...row }

      this.cardModalVisibled = true
    },

    onAddModal () {
      this.cardData = {}

      this.cardModalVisibled = true
    },

    async fetchCards() {
      const query = this.$route.query || {}

      const { piece, count } = await this.$store.dispatch('getCards', {
        params: {
          search: query.search || '',
          page: this.page
        }
      })
      
      this.cards = piece
      this.pageCount = count
    },

    async remove({ id }) {
      await this.$buefy.dialog.confirm({
        message: "Видалити картку",
        onConfirm: async () => {
          await api({
            method: "delete",
            point: `cards/${id}`
          })

          this.fetchCards();
        }
      });
    }
  }
};
</script>
